import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'wm-access-shell',
  imports: [RouterOutlet],
  templateUrl: './access-shell.component.html',
  styleUrl: './access-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccessShellComponent {}
